export default function ytVidId( url )
{
  const trimUrl = url.trim();
  const p = /^(?:https?:\/\/)?(?:www\.)?(?:youtu\.be\/|youtube\.com\/(?:embed\/|v\/|watch\?v=|watch\?.+&v=))((\w|-){11})(?:\S+)?$/;
  return ( trimUrl.match( p ) ) ? RegExp.$1 : false;
}
